import { useEffect } from 'react'

import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '../../Store/hooks/useStore'
import { useSelectionStyle } from '../useSelectionStyle'

export const useFontFamily = () => {
  const { defaultFontFamily, currentFontFamily, setCurrentFontFamily } =
    useRichEditorStore(state =>
      pick(state, [
        'defaultFontFamily',
        'currentFontFamily',
        'setCurrentFontFamily'
      ])
    )

  const [fontFamily, setFontFamily] = useSelectionStyle({
    name: 'font-family',
    defaultValue: defaultFontFamily
  })

  useEffect(() => {
    setCurrentFontFamily(fontFamily)
  }, [fontFamily, setCurrentFontFamily])

  return {
    fontFamily: currentFontFamily,
    setFontFamily
  }
}
